import { render, staticRenderFns } from "./NotAllowed.vue?vue&type=template&id=0b6a9ce8"
import script from "./NotAllowed.vue?vue&type=script&lang=ts"
export * from "./NotAllowed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports